import React, { useState } from 'react';
import LineaNegocio from '../../components/admin/LineaNegocio';
import { TextField, Button, Grid, Typography, Divider, Container } from '@mui/material';
import apiInstance from '../../services/ServiceApi';
import FichaValidacion from '../../components/admin/validacion/FichaValidacion';
import DataVenta from '../../components/admin/validacion/DataVenta';
import EstadoValidacion from '../../components/admin/EstadoValidacion';


const Validacion = () => {
  const [selectedLinea, setSelectedLinea] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [estado, setEstado] = useState('');
  const [datos, setDatos] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [formulario, setFormulario] = useState(false);
 
  const handleLineaChange = (selectedLinea) => {
    setSelectedLinea(selectedLinea.id);
    setFormulario(selectedLinea.formulario);
  };

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
 
  useState(() => {
    const currentDate = getCurrentDate();
    setStartDate(currentDate);
    setEndDate(currentDate);
  }, []);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleEstadoChange = (selectEstado) => {
    setEstado(selectEstado);
  };
  
  const handleValidarClick = (row) => {
    setSelectedRow(row);
    setModalOpen(true);
  };
  const handleUpdate = async () => {
    try {
      const data = { inicio: startDate, fin: endDate, linea_negocio_id: selectedLinea, estado_validacion: estado };
      const response =await apiInstance.post('/ventas/', data);
      setDatos(response.data);
    } catch (error) {
      setDatos([]);
  
      console.error('Error al hacer la solicitud:', error);
    }
  };
  
  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = { inicio: startDate, fin: endDate, linea_negocio_id: selectedLinea, estado_validacion: estado };

    try {
      const response = await apiInstance.post('/ventas/', data);
      setDatos(response.data);
    } catch (error) {
      setDatos([]);

      console.error('Error al hacer la solicitud:', error);
    }
  };
  return (
    <Container elevation={3}>
      <Typography variant="h6" gutterBottom>
        Validaciones de Encuestas / Ventas
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <LineaNegocio onLineaChange={handleLineaChange} />
          </Grid>
          <Grid item xs={4}>
              <EstadoValidacion onEstadoChange={handleEstadoChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Fecha de inicio" type="date" value={startDate} onChange={handleStartDateChange} fullWidth InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Fecha de fin" type="date" value={endDate} onChange={handleEndDateChange} fullWidth InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>Buscar</Button>
          </Grid>
        </Grid>
        <Divider style={{marginTop: '20px', marginBottom: '20px'}}/>
        {datos && <FichaValidacion datos={datos} onValidarClick={handleValidarClick} />}
        {selectedRow && (
          <>
            <DataVenta open={modalOpen} onClose={handleModalClose} datos={selectedRow} campos={formulario} handleUpdate={handleUpdate} />
          </>
        )}
      </form>
      </Container>
  );
};

export default Validacion;